import { Address } from '../address';

export class OrderShippingPickup {
  company: string;
  name: string;
  phone: string;

  constructor(
    public shipmentDate?: Date,
    public earliestPickupTime?: string,
    public latestPickupTime?: string,
    public pickupComment?: string,
    public address?: Address,
    public isPickupRequired?: boolean
  ) { }
}
